import { DropDownList } from "@progress/kendo-react-dropdowns";
import { InputField } from "../../components/form/input.field.component";
import { API_END_POINT } from "../../constants";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import VehicleTypeModel from "../../models/masters/vehicletype-model";
import * as Yup from "yup";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { useGetVehicleTypes } from "../../apiclient/master/useGetVehicleTypeApi";

interface VehicleTypeEditProps {
    data: VehicleTypeModel;
    isViewMode?: boolean; // 
    onClose?: (status: SubmitStatus, data: any) => any;
  }


const VehicleTypeEntry: React.FC<VehicleTypeEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode} = props;
    const title = data?.vehicleTypeId > 0 ? "Edit Vehicle Type" : "Add Vehicle Type";
  
    let initialValue: VehicleTypeModel = {
      vehicleTypeId: data?.vehicleTypeId ? data.vehicleTypeId : 0,
      name: data?.name, 
      notes:data?.notes,
      isActive: data?.vehicleTypeId > 0 ? data.isActive : true,
    };
    const validationSchema = Yup.object().shape({
      name: Yup.string()
      .required("Required")
      .test("check-duplicate-name", "VehicleType name already exists", (value) => {
        // Ensure the value is compared in a case-insensitive manner
        return (
          value &&
          !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
          (data?.name && value === data.name) // Allow current name during update
        );
      }), 

    
    });
    console.log(initialValue)
  
    const [existingName, setExistingName] = useState<string[]>([]); // state to hold existing zone names
    const { data: fetchedVehicleType } = useGetVehicleTypes(); // Fetching existing zones data

    useEffect(() => {
        if (fetchedVehicleType) {
            setExistingName(fetchedVehicleType.map((zone: any) => zone.name)); // Extracting zone names to compare against
        }
    }, [fetchedVehicleType]);
    return (
      
      <>
        <FormikModelDialog
          width="50%"
          title={title}
          initialData={initialValue}
          validationSchema={validationSchema}
          show={!!data}
          onClose={onClose}
          endpoint={API_END_POINT.MASTER}
          showAddAnother={true}
          postRoute="VehicleType/SaveVehicleType"
          isViewOnly ={isViewMode}
          isUpDateEntityDetails={data?.vehicleTypeId>0? true: false}

          
        >
          <div>
          <div className="row">
            <div className="col-4">
              <InputField maxLength={100} label="Vehicle Type *" name="name" />
            </div>
            <div className="col-6">
              <InputField maxLength={100} label="Notes" name="notes" />
            </div>
            <div className="col-6">
                  <CheckboxField  isChecked={true} label="Is Active?" name="isActive"  checkstyle={CheckBoxStyle.Normal} />
              </div>
           
          </div>
        </div>
        </FormikModelDialog>
      </>
    );
  };
   

  export default VehicleTypeEntry;